// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.trash-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: 1px solid transparent;
  border-radius: 6px;
  background: transparent;
  color: #8a8a8a;
  cursor: pointer;
  transition: color 0.15s ease, background 0.15s ease, border-color 0.15s ease;
}

.trash-button:hover {
  color: #b91c1c;
  background: #fee2e2;
  border-color: #fecaca;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/TrashButton.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,4EAA4E;AAC9E;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB","sourcesContent":[".trash-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  border: 1px solid transparent;\n  border-radius: 6px;\n  background: transparent;\n  color: #8a8a8a;\n  cursor: pointer;\n  transition: color 0.15s ease, background 0.15s ease, border-color 0.15s ease;\n}\n\n.trash-button:hover {\n  color: #b91c1c;\n  background: #fee2e2;\n  border-color: #fecaca;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
